var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-row',[_c('div',{staticClass:"pageHeaderDocumentation p-3"},[_c('c-container',{staticClass:"h-100 d-flex align-items-center"},[_vm._t("header")],2)],1),_c('c-container',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }